import React, { useEffect, useState } from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';
import { Box, ClickAwayListener, Grid, Modal, TextField, Typography } from '@mui/material';

import styled from '@emotion/styled';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import './PostModal.css';
// import { useTranslate } from 'react-redux-multilingual';
// import { useSnackbar } from 'notistack';
import { StyledLabel } from '../../components/StyledComponents';
// import ApiService from '../../helpers/apiHelper';
import { connect, useDispatch } from 'react-redux';
import { LetsGoBtn3 } from '../../components/Buttons';
import { setIsOpenImageCropModal, setIsOpenPostModal } from '../../redux/mainReducer';
// import { useSnackbar } from 'notistack';
// import {  encode as btoa, decode as atob } from 'base-64';
// import sha256 from 'crypto-js/sha256';
// import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import EmojiPicker from 'emoji-picker-react';
import { useSnackbar } from 'notistack';
import { useTranslate } from 'react-redux-multilingual';
import { Spinner } from '../../components/Spinner';
import ApiService from '../../helpers/apiHelper';
import { ImageOutlined } from '@mui/icons-material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: { xs: 390, sm: 710, md: 820, lg: 1100, xl: 1100 },
  bgcolor: 'background.paper',
  borderRadius: '8px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px ', md: '50px 60px 50px 60px' },
  overflow: 'scroll',
  height: 'auto',
  maxHeight: { xs: '100vh', sm: '85vh' },
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#7C7C7C',
    opacity: 1,
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInputBase-root': {
    alignItems: 'end',
    backgroundColor: '#FFFFFF !important',
    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px'
  },

  fontFamily: 'FixelText-Regular !important',
  margin: '5px 0px',

  '& ::placeholder': {
    color: '#7C7C7C',
    opacity: 1
  },

  '& .MuiInputBase-root.Mui-error': {
    backgroundColor: '#FFE5E5 !important'
  }
});

function PostModal({ isOpenModal, language, setter, data }) {
  const [imgs, setImgs] = useState([]);
  const [newImgs, setNewImgs] = useState([]);
  const [imgsToDelete, setImgsToDelete] = useState([]);

  const [screenType, setScreenType] = useState('desktop');
  const [isShowEmoji, setIsShowEmoji] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (window.screen.width <= 600) {
      setScreenType('mobile');
    }
  }, []);
  const translate = useTranslate();
  const { enqueueSnackbar } = useSnackbar();
  const api = new ApiService(`posts/post${data ? '/' : ''}${data ? data.id : ''}`, translate);
  const photoApi = new ApiService('photo/bucket/upload-file');
  // const photoApi = new ApiService('/bucket/upload-file');
  // const api = new ApiService(`post${data ? '/' : ''}${data ? data.id : ''}`, translate);

  // const apiPhoto = new ApiService('photo/get-photo');
  // const apiPhoto = new ApiService('get-photo');
  const schema = Yup.object().shape(
    {
      description: Yup.string().when('description', (val, schema) => {
        if (imgs.length === 0) {
          return Yup.string()
            .min(1, 'Мінімально 1 символ')
            .max(1000, 'Максимально 1000 символів')
            .required('Мінімально 1 символ');
        } else {
          return Yup.string().max(1000, 'Максимально 1000 символів');
        }
      })
    },
    [['description', 'description']]
  );

  const formik = useFormik({
    initialValues: {
      description: data?.description ? data.description : ''
    },
    enableReinitialize: true,
    validationSchema: schema,

    onSubmit: async (values, { resetForm, setErrors }) => {
      setIsLoading(true);
      if (data) {
        const imgsNew = await Promise.all(
          newImgs.map((img) => photoApi.sendRequest({ file: img }, true).then((res) => res.result))
        );
        api
          .updateData({ ...values, newPhotos: imgsNew, listDeletedPhotos: imgsToDelete }, false)

          .then((res) => {
            if (setter) {
              setter(false);
            }
            dispatch(setIsOpenPostModal({ isOpen: false, func: null, data: null }));
            setIsShowEmoji(false);
            enqueueSnackbar('Зміни збережено', { variant: 'success' });
            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
            enqueueSnackbar('Сталась помилка', { variant: 'error' });
          });
      } else {
        const photoIds = await Promise.all(
          imgs.map((img) => photoApi.sendRequest({ file: img }, true).then((res) => res.result))
        );
        api
          .sendRequest({ ...values, photoIds: photoIds }, false)
          .then((res) => {
            if (setter) {
              setter(false);
            }
            dispatch(setIsOpenPostModal({ isOpen: false, func: null, data: null }));
            setIsShowEmoji(false);
            enqueueSnackbar('Пост успішно створено', { variant: 'success' });
            setIsLoading(false);
            resetForm();
          })
          .catch((error) => {
            console.log(error);
            console.error(error);
            setIsLoading(false);
            enqueueSnackbar('Сталась помилка', { variant: 'error' });
          });
      }
    }
  });
  // function getFileFromBase64(string64, fileName) {
  //   const trimmedString = string64.replace('dataimage/jpegbase64', '');
  //   const imageContent = atob(trimmedString);
  //   const buffer = new ArrayBuffer(imageContent.length);
  //   const view = new Uint8Array(buffer);

  //   for (let n = 0; n < imageContent.length; n++) {
  //     view[n] = imageContent.charCodeAt(n);
  //   }
  //   const type = 'image/jpeg';
  //   const blob = new Blob([buffer], { type });
  //   return new File([blob], fileName, { lastModified: new Date().getTime(), type });
  // }
  useEffect(() => {
    if (data) {
      const getPhotos = async () => {
        setImgs([...data?.photoUrls]);
      };
      getPhotos();

      // setImgs([
      //   ...data.encodedPhotos.map((photo) => getFileFromBase64(photo.encodedContent, data.nameFile))
      // ]);
    }
    // eslint-disable-next-line
    return () => {
      setImgs([]);
      setNewImgs([]);
      setImgsToDelete([]);
    };
  }, [data]);

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    submitForm,
    resetForm,
    setErrors,
    setFieldValue
  } = formik;

  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }
          dispatch(setIsOpenPostModal({ isOpen: false, func: null, data: null }));

          resetForm();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_post_modal"
      >
        <Box sx={style} className="bonfair_post_modal-box">
          <CloseIcon
            className="bonfair_post_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenPostModal({ isOpen: false, func: null, data: null }));

              resetForm();
            }}
          />

          <FormikProvider value={formik}>
            <Form
              autoComplete="off"
              noValidate
              onSubmit={handleSubmit}
              style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}
            >
              <Grid container spacing={screenType !== 'desktop' ? 1 : 2}>
                <Grid item xs={12} md={12} lg={12}>
                  <StyledLabel className="postModal-title-text">
                    {/* {translate('bonfair_service_modal')} */}
                    {data ? 'Редагуємо пост' : 'Створюємо пост'}
                  </StyledLabel>
                </Grid>
                {/* <Grid  item sx={{ mb: 4, mt:8, display:'flex' }}>
              
                <Avatar
                  sx={{
                    width: 70,
                    height: 70,
                    // mr: 2,
                    border: '1px solid #60A5DF'
                  }}
                />
             
              
                <Stack sx={{ width: '100%', marginLeft:'20px', marginTop:'10px' }}>
                  <Typography
                    fontSize={24}
                    lineHeight="29px"
                    fontWeight={400}
                    sx={{ position: 'relative' }}
                  >
                    @TEST
                  </Typography>
                  <Typography fontSize={16} lineHeight="20px" fontWeight={400}>
                    Name Surname
                  </Typography>
                </Stack>
              
             
            </Grid> */}
                {!data && (
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontSize: 16, fontFamily: 'FixelText-Regular' }}
                    >
                      Текст
                    </Typography>
                  </Grid>
                )}

                <Grid item xs={12} sx={{ position: 'relative', height: '265px' }}>
                  <CssTextField
                    placeholder="Чим хочеш поділитися сьогодні? "
                    multiline
                    rows={8}
                    fullWidth
                    inputProps={{ style: { textAlign: 'left' } }}
                    InputProps={{
                      endAdornment: (
                        <>
                          <EmojiEmotionsOutlinedIcon
                            onClick={() => {
                              setIsShowEmoji(!isShowEmoji);
                            }}
                            sx={{
                              display: { xs: 'none', md: 'inline-block' },
                              color: '#60A5DF',
                              cursor: 'pointer',
                              fontSize: '20px',
                              mr: 1
                            }}
                          />
                        </>
                      )
                    }}
                    error={Boolean(touched.description && errors.description)}
                    {...getFieldProps('description')}
                    value={values.description}
                  >
                    {values.description}
                  </CssTextField>
                  {values.description.length !== 0 && (
                    <p
                      style={{
                        margin: '0 5px',
                        color: 'gray',
                        textAlign: 'right',
                        fontSize: '14px'
                      }}
                    >{`${values.description.length}/1000`}</p>
                  )}

                  {touched.description && errors.description && (
                    <div
                      style={{
                        color: 'red',
                        margin: '5px 0px',
                        fontSize: '14px',
                        fontFamily: 'FixelText-Regular'
                      }}
                    >
                      {errors.description}
                    </div>
                  )}
                  {isShowEmoji && (
                    <ClickAwayListener
                      onClickAway={() => {
                        setIsShowEmoji(false);
                      }}
                    >
                      <Box>
                        <EmojiPicker
                          onEmojiClick={(emojiData, event) => {
                            let newStr = `${values.description}${emojiData.emoji}`;
                            setFieldValue('description', newStr);
                          }}
                          skinTonesDisabled
                          searchDisabled
                          previewConfig={{ showPreview: false }}
                          style={{
                            position: 'absolute',
                            bottom: '-280px',
                            right: '50px',
                            zIndex: '99'
                          }}
                          width={'60%'}
                          height={'300px'}
                        />
                      </Box>
                    </ClickAwayListener>
                  )}
                </Grid>
                {!data && (
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 2, fontSize: 16, fontFamily: 'FixelText-Regular' }}
                    >
                      Додай фото
                    </Typography>
                    <Typography variant="subtitle" sx={{ fontSize: 16, color: '#B1B1B1' }}>
                      Можливо завантажити до 10 вкладень. Один елемент не має важити більше 10 МБ.
                    </Typography>
                  </Grid>
                )}

                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                >
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'flex-start',
                      gap: '12px',
                      alignSelf: 'stretch',
                      zIndex: '99',
                      // paddingTop: '14px',
                      padding: '12px',
                      marginBottom: '20px',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                      background: 'white',
                      borderRadius: '5px'
                    }}
                  >
                    {imgs.length !== 0 &&
                      imgs.map((file, index) => (
                        <div
                          key={'image' + index}
                          className="uploaded-img-modal"
                          // style={
                          //   index === 0 || index === imgs.length - 1
                          //     ? { marginLeft: '10px', marginTop: '14px' }
                          //     : { marginLeft: '14px', marginTop: '14px' }
                          // }
                          // style={{ margin: 'auto' }}
                        >
                          {index === 0 ? (
                            <div
                              style={{
                                position: 'absolute',
                                backgroundColor: '#E2F2FF',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                                fontFamily: 'FixelText-Medium',
                                fontWeight: '500',
                                color: '#60A5DF',
                                fontSize: '14px',
                                top: '4px',
                                left: '4px'
                              }}
                            >
                              Обкладинка
                            </div>
                          ) : null}
                          <img
                            style={{ objectFit: 'cover' }}
                            alt={'img' + index}
                            width={60}
                            src={typeof file === 'string' ? file : URL.createObjectURL(file)}
                          />
                          <div
                            style={{
                              position: 'absolute',
                              backgroundColor: 'white',
                              width: '26px',
                              height: '26px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              borderRadius: '50px',
                              boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                              cursor: 'pointer',
                              top: '4px',
                              right: '4px'
                            }}
                            onClick={() => {
                              const newArray = imgs;
                              const newImgsToDelete = imgsToDelete;

                              if (data) {
                                const match = data.photoUrls
                                  .find((file, i) => index === i)
                                  // eslint-disable-next-line
                                  .match(/com\/([^?]+)/);
                                const imgPath = match ? `img/${match[1].split('img/')[1]}` : null;
                                newImgsToDelete.push(imgPath);
                              }

                              newArray.splice(index, 1);
                              setImgs([...newArray]);
                              setImgsToDelete([...newImgsToDelete]);
                            }}
                          >
                            <CloseIcon sx={{ fontSize: '20px' }} />
                          </div>
                        </div>
                      ))}
                    <input
                      multiple
                      accept=".jpeg,.jpg,.png"
                      // style={{ display: 'none' }}
                      style={{ position: 'absolute', opacity: 0, zIndex: 99, display: 'none' }}
                      id="button-file-post"
                      disabled={imgs.length === 10 ? true : false}
                      onChange={(event) => {
                        if (imgs.length !== 10) {
                          dispatch(
                            setIsOpenImageCropModal({
                              isOpen: true,
                              file: event.target.files[0],
                              setter: (file) => {
                                setErrors({});
                                if (data) {
                                  const newImgsArray = [...newImgs];
                                  newImgsArray.push(file);
                                  setNewImgs([...newImgsArray]);
                                }
                                const newArray = [...imgs];
                                newArray.push(file);
                                setImgs([...newArray]);
                              }
                            })
                          );
                        }
                      }}
                      type="file"
                    />
                    {imgs.length !== 10 && (
                      <label htmlFor="button-file-post">
                        <div className="uploaded-img-modal-label">
                          <ImageOutlined
                            style={{ color: 'black' }}
                            sx={{
                              mt: 1,
                              fontSize: 35,
                              '&:hover': {
                                width: 100
                              }
                            }}
                          />
                          <Typography
                            sx={{
                              mt: 2,
                              display: 'flex',
                              alignItems: 'center',
                              fontFamily: 'FixelText-Medium'
                            }}
                          >
                            <AddIcon sx={{ color: 'black', mr: '2px' }} /> Додати
                          </Typography>
                        </div>
                      </label>
                    )}
                  </div>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
                >
                  {!isLoading ? (
                    <LetsGoBtn3
                      disabled={values.description.length === 0 && imgs.length === 0}
                      size="large"
                      onClick={() => {
                        submitForm();
                      }}
                      width={257}
                      style={{ textTransform: 'inherit' }}
                      text={data ? 'Зберегти зміни' : 'Створити'}
                    />
                  ) : (
                    <div style={{ marginTop: '10px' }}>
                      <Spinner type="small" />
                    </div>
                  )}
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    isOpenSearchBar: state.global.isOpenSearchBar
  };
};
export default connect(mapStateToProps)(PostModal);
